import React, { Component } from 'react';
import PropTypes from 'prop-types';

class OKReferenceLineLabel extends Component {
    render() {
        const {
            preLabel,
            label,
            viewBox
        } = this.props;
        const x = viewBox.width + viewBox.x + 5;
        const y = viewBox.y - 6;
        return (
            <g>
                <text x={x} y={y} fontSize={13} >
                    { preLabel }
                </text>
                <text x={x} y={y + 20} fontSize={13} >
                    { label }
                </text>
            </g>
        )
    }
}

OKReferenceLineLabel.propTypes = {
    preLabel: PropTypes.string,
    label: PropTypes.string,
    viewBox: PropTypes.object
};

export default OKReferenceLineLabel;